// import React, { useState, useEffect } from "react";
// import { FaBell, FaSignOutAlt, FaChevronDown, FaTimes } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { CgProfile } from "react-icons/cg";
// import { MdOutlineLocationOn } from "react-icons/md";
// import Cookies from "js-cookie";

// // Decode JWT token function to extract the payload
// const decodeJWT = (token) => {
//   try {
//     return JSON.parse(atob(token.split(".")[1])); // Decode the payload of the JWT token
//   } catch (error) {
//     console.error("Failed to decode token:", error);
//     return null;
//   }
// };

// const Header = () => {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [isLoggedOut, setIsLoggedOut] = useState(false);
//   const [user, setUser] = useState(null);
//   const navigate = useNavigate();

//   // Decode token and get user data from it
//   useEffect(() => {
//     const token = Cookies.get("access_token"); // Get the access token from cookies
//     if (token) {
//       const decodedUser = decodeJWT(token); // Decode the token to extract user info
//       if (decodedUser) {
//         setUser({
//           name: decodedUser.first_name, // Assuming the JWT contains the user's first name
//           email: decodedUser.email, // Assuming the JWT contains the user's email
//           permissions: decodedUser.permissions, // Assuming the JWT contains the user's permissions
//         });
//       }
//     }

//     if (isLoggedOut) {
//       const timeout = setTimeout(() => {
//         navigate("/login");
//       }, 100);
//       return () => clearTimeout(timeout);
//     }
//   }, [isLoggedOut, navigate]);

//   const handleLogout = () => {
//     Cookies.remove("access_token"); // Remove the token from cookies
//     Cookies.remove("refresh_token"); // Remove the token from cookies
//     localStorage.clear();
//     setIsLoggedOut(true); // Set the logged-out state
//     navigate("/login"); // Redirect to login
//   };

//   const toggleDropdown = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   const closeDropdown = () => {
//     setDropdownOpen(false);
//   };

//   // If no user is logged in, show the default "Hello User" UI
//   if (!user) {
//     return (
//       <div className="sticky top-0 z-50 flex flex-col md:flex-row sm:flex-row justify-between items-center bg-white px-3 py-3 shadow-md">
//         <div className="mb-4 md:mb-0 text-center md:text-left">
//           <h1 className="text-base font-bold">Hello, User</h1>
//           <h2 className="text-gray-500 text-xs">Have a Nice day :)</h2>
//         </div>
//         <div className="flex items-center space-x-4">
//           <div className="relative">
//             <FaBell className="text-black" size={16} />
//             <div className="absolute top-0 right-0 w-2 h-2 bg-green-500 rounded-full border border-white"></div>
//           </div>
//           <div
//             className="flex items-center cursor-pointer relative"
//             onClick={toggleDropdown}
//           >
//             <div className="hidden md:block text-gray-400">|</div>
//             <div className="ml-2 w-8 h-8 md:w-10 md:h-10 bg-black rounded-full flex items-center justify-center text-white font-bold text-base">
//               U
//             </div>
//             <div className="ml-2 hidden md:flex flex-col">
//               <p className="font-semibold text-xs">User</p>
//               <p className="text-gray-500 text-xs font-semibold">
//                 user@gmail.com
//               </p>
//             </div>
//             <FaChevronDown className="ml-2 text-gray-500" />
//             {dropdownOpen && (
//               <div className="absolute right-0 top-12 mt-2 w-48 bg-white border rounded-md shadow-lg z-10">
//                 <div className="flex justify-between items-center p-2 border-b">
//                   <span className="font-bold">Menu</span>
//                   <FaTimes className="cursor-pointer" onClick={closeDropdown} />
//                 </div>
//                 <button
//                   onClick={handleLogout}
//                   className="flex items-center p-2 text-red-500 hover:bg-gray-100 w-full text-left"
//                 >
//                   <FaSignOutAlt size={24} className="mr-3" /> Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const { name, email, permissions } = user;

//   return (
//     <div className="sticky top-0 z-50 flex flex-col md:flex-row sm:flex-row justify-between items-center bg-white px-3 py-3 shadow-md">
//       <div className="mb-4 md:mb-0 text-center md:text-left">
//         <h1 className="text-base font-bold capitalize">Hello, {name}</h1>
//         <h2 className="text-gray-500 text-xs">Have a Nice day :)</h2>
//       </div>
//       <div className="flex items-center space-x-6">
//         <div className="relative group cursor-pointer">
//           <FaBell className="text-black" size={16} />
//           <div className="absolute top-0 right-0 w-2 h-2 bg-green-500 rounded-full border border-white"></div>
//           <div className="absolute bottom-3 left-3 text-xs text-white font-medium bg-black px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity z-10">
//             Online
//           </div>
//         </div>

//         <div className="flex items-center  relative" onClick={toggleDropdown}>
//           <div className="hidden md:block text-gray-400 mr-4">|</div>
//           <div className="ml-2 w-8 h-8 md:w-10 md:h-10 bg-black rounded-full flex items-center justify-center text-white font-bold text-base cursor-pointer capitalize">
//             {name && name.charAt(0)}
//           </div>
//           <div className="ml-2 hidden md:flex flex-col cursor-pointer">
//             <p className="font-semibold text-xs capitalize">{name}</p>
//             <p className="text-gray-500 text-xs font-semibold">{email}</p>
//           </div>
//           <FaChevronDown className="ml-2 text-gray-500 cursor-pointer" />
//           {dropdownOpen && (
//             <div className="absolute right-0 top-12 mt-2 w-48 bg-white border rounded-md shadow-lg z-10">
//               <div className="flex justify-between items-center p-2 border-b">
//                 <span className="font-bold">Menu</span>
//                 <FaTimes className="cursor-pointer" onClick={closeDropdown} />
//               </div>
//               <button
//                 onClick={() =>
//                   navigate("/dashboard/system-config/wide-settings")
//                 }
//                 className="flex items-center p-2 text-black hover:bg-gray-100 w-full text-left"
//               >
//                 <CgProfile className="mr-2" /> Profile
//               </button>
//               <button
//                 onClick={() => navigate("/dashboard/region")}
//                 className="flex items-center p-1.5  hover:bg-gray-100 w-full text-left"
//               >
//                 <MdOutlineLocationOn size={20} className="mr-2" /> Region
//               </button>
//               <button
//                 onClick={handleLogout}
//                 className="flex items-center px-2.5 py-1.5 text-red-500 hover:bg-gray-100 w-full text-left"
//               >
//                 <FaSignOutAlt className="mr-2" /> Logout
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;

import React, { useState, useEffect } from 'react';
import { FaBell, FaSignOutAlt, FaChevronDown, FaTimes } from 'react-icons/fa';
import { CgProfile } from 'react-icons/cg';
import { MdOutlineLocationOn } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '.././Authentication/auth'; // Update the path as per your project structure
const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      const currentUser = await getCurrentUser();
      if (currentUser) {
        setUser(currentUser);
      }
    };

    fetchUser();

    if (isLoggedOut) {
      const timeout = setTimeout(() => {
        navigate('/login');
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [isLoggedOut, navigate]);

  const handleLogout = async () => {
    try {
      await fetch(`${AQ_BASE_URL}/aq/api/logout`, {
        method: 'POST',
        credentials: 'include', // ensures cookies are sent with request
      });
    } catch (error) {
      console.error('Logout failed:', error);
      // Optionally show user a message or retry
    }

    localStorage.clear();
    setIsLoggedOut(true);
    navigate('/login');
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const closeDropdown = () => setDropdownOpen(false);

  const name = user?.first_name || 'User';
  const email = user?.email || 'user@gmail.com';

  return (
    <div className="sticky top-0 z-50 flex flex-col md:flex-row sm:flex-row justify-between items-center bg-white px-3 py-3 shadow-md">
      <div className="mb-4 md:mb-0 text-center md:text-left">
        <h1 className="text-base font-bold capitalize">Hello, {name}</h1>
        <h2 className="text-gray-500 text-xs">Have a Nice day :)</h2>
      </div>
      <div className="flex items-center space-x-6">
        <div className="relative group cursor-pointer">
          <FaBell className="text-black" size={16} />
          <div className="absolute top-0 right-0 w-2 h-2 bg-green-500 rounded-full border border-white"></div>
          <div className="absolute bottom-3 left-3 text-xs text-white font-medium bg-black px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity z-10">
            Online
          </div>
        </div>

        <div className="flex items-center relative" onClick={toggleDropdown}>
          <div className="hidden md:block text-gray-400 mr-4">|</div>
          <div className="ml-2 w-8 h-8 md:w-10 md:h-10 bg-black rounded-full flex items-center justify-center text-white font-bold text-base cursor-pointer capitalize">
            {name.charAt(0)}
          </div>
          <div className="ml-2 hidden md:flex flex-col cursor-pointer">
            <p className="font-semibold text-xs capitalize">{name}</p>
            <p className="text-gray-500 text-xs font-semibold">{email}</p>
          </div>
          <FaChevronDown className="ml-2 text-gray-500 cursor-pointer" />
          {dropdownOpen && (
            <div className="absolute right-0 top-12 mt-2 w-48 bg-white border rounded-md shadow-lg z-10">
              <div className="flex justify-between items-center p-2 border-b">
                <span className="font-bold">Menu</span>
                <FaTimes className="cursor-pointer" onClick={closeDropdown} />
              </div>
              <button
                onClick={() => navigate('/dashboard/system-config/wide-settings')}
                className="flex items-center p-2 text-black hover:bg-gray-100 w-full text-left"
              >
                <CgProfile className="mr-2" /> Profile
              </button>
              <button
                onClick={() => navigate('/dashboard/region')}
                className="flex items-center p-1.5 hover:bg-gray-100 w-full text-left"
              >
                <MdOutlineLocationOn size={20} className="mr-2" /> Region
              </button>
              <button
                onClick={handleLogout}
                className="flex items-center px-2.5 py-1.5 text-red-500 hover:bg-gray-100 w-full text-left"
              >
                <FaSignOutAlt className="mr-2" /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
